import { render, staticRenderFns } from "./AttachmentUpload.vue?vue&type=template&id=2f203a60&"
import script from "./AttachmentUpload.vue?vue&type=script&lang=js&"
export * from "./AttachmentUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports